import { render, staticRenderFns } from "./SuccessCorporateRegistration.vue?vue&type=template&id=76ef699e"
import script from "./SuccessCorporateRegistration.vue?vue&type=script&lang=js"
export * from "./SuccessCorporateRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports